export const onRegionChangeHandler = (region: ILocationV2) => {
  const { alias } = region;
  const { href, pathname } = window.location;

  if (!pathname.includes('/region/')) {
    window.location.reload();
    return;
  }

  const newPathname = pathname.replace(/\/region\/[^/]+(\/)?/, `/region/${alias}$1`);
  window.location.href = href.replace(pathname, newPathname);
};
